/**
 * サンプルクラス
 * @constructor
 */
class HistoryScroll {

  constructor() {
    this.init();
  }

  /**
  * 初期化メソッド
  * ページ内に指定された要素（.js-historyScroll）が存在する場合実行する
  *
  */
  init() {
    if (document.querySelector('.js-historyScroll')) {
      this.historyScroll('.js-historyScroll');
      this.historyScroll('.js-historyNavScroll');
    }
  }
  historyScroll(target) {
    /*
    下記プログラムは
    https://zenn.dev/portinc/articles/smooth-scroll-add
    上記を参考に作っています
    */
    const items = document.querySelectorAll(target);
    const header = document.querySelector('header');
    let durationTime;
    items.forEach((item, index) => {
      item.addEventListener('click', () => {
        const headerHeight = header.getBoundingClientRect().height;
        const targetId = item.getAttribute('data-anchor-target');
        const targetElement = document.querySelector(targetId);
        if (target === '.js-historyScroll') {
          if (index === 0) {
            durationTime = 1000;
          } else if (index === 1) {
            durationTime = 1400;
          } else if (index === 2) {
            durationTime = 1800;
          } else if (index === 3) {
            durationTime = 2200;
          }
        } else {
          durationTime = 1500;
        }
        animateScroll(targetElement, durationTime, headerHeight);
      });
    });

    const animateScroll = (target, duration, headerHeight) => {
      const initialPosition = window.pageYOffset; // スクロールの初期位置
      const targetPosition = target.getBoundingClientRect().top + initialPosition - headerHeight;
      const animationStart = performance.now();

      const performAnimation = (currentTime) => {
        const elapsedTime = currentTime - animationStart;
        const progress = elapsedTime / duration;

        if (progress < 1) {
          const easedProgress = easingFunction(progress);
          const currentPosition = initialPosition +
            ((targetPosition - initialPosition) * easedProgress);
          window.scrollTo(0, currentPosition);
          requestAnimationFrame(performAnimation);
        } else {
          window.scrollTo(0, targetPosition);
        }
      };

      requestAnimationFrame(performAnimation);
    };

    const easingFunction = (t) => (
      t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
    );


  }
}

export default HistoryScroll;
